<template>
  <b-modal :active.sync="isActiveModal"
    has-modal-card
    trap-focus
    aria-role="dialog"
    aria-modal class="has-overflow">
      <div class="modal-card">
        <ValidationObserver ref="observer">
          <header class="modal-card-head">
              <p class="modal-card-title">Descarga Informe ICA</p>
          </header>
          <section class="modal-card-body">
            <ValidationProvider
              name="Rango de Fechas"
              :rules="'required'"
              v-slot="{ errors }">
            <b-field label="Rango de Fechas"
            :type="{ 'is-danger': errors[0] }"
            :message="errors">
              <b-datepicker
                    placeholder="Selecciona un rango de fechas"
                    :first-day-of-week="1"
                    v-model="dates"
                    @input="changeDate"
                    :month-names="$moment.months()"
                    :day-names="$moment.weekdaysShort()"
                    :unselectable-days-of-week="[0]"
                    :mobile-native="false"
                    :nearby-selectable-month-days="true"
                    range expanded>
                    <button class="button is-danger"
                        @click="dates = []">
                        <b-icon icon="close"></b-icon>
                        <span>Limpiar</span>
                    </button>
              </b-datepicker>
            </b-field>
            </ValidationProvider>
            <b-field label="Todos los jinetes">
                <b-switch
                  v-model="allRiders"
                  >
                  {{ switchLabel }}
                </b-switch>
            </b-field>
            <b-field v-if="!allRiders">
              <rider-selector @select="rider = $event" :has-validator="true" rules="required" label="Jinete" name="rider" :params="{'user_status_id': 1}"/>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button type="is-info" @click="save" :loading="isLoading" expanded>Descargar</b-button>
          </footer>
        </ValidationObserver>
      </div>
    </b-modal>
</template>

<script>
import RiderSelector from '@/components/RiderSelector'
import TaskUserService from '@/services/TaskUserService'

export default {
  components: {
    RiderSelector
  },
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dates: [],
      rider: null,
      isActiveModal: false,
      isLoading: false,
      allRiders: true
    }
  },
  methods: {
    resetForm () {
      this.dates = []
      this.rider = null
      this.allRiders = true
    },
    changeDate (dates) {
      if (dates && dates.length > 0) {
        // let start = this.$moment(dates[0]).weekday(0).toDate()
        // let end = this.$moment(dates[1]).weekday(5).toDate()
        let start = this.$moment(dates[0]).toDate()
        let end = this.$moment(dates[1]).toDate()

        this.dates = [start, end]
      }
    },
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true
        this.openAlert()
        let fromDate = this.$moment(this.dates[0]).format('YYYY-MM-DD').toString()
        let toDate = this.$moment(this.dates[1]).format('YYYY-MM-DD').toString()
        let userfilter = this.userId && !this.allRiders ? { user_id: this.userId } : {}

        let params = {
          from: fromDate,
          to: toDate,
          ...userfilter
        }

        let response = await TaskUserService.exportICADocuent(params)

        if (response) {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          var fileURL = window.URL.createObjectURL(blob)
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', `Informe ICA al ${toDate}.pdf`)
          document.body.appendChild(fileLink)
          fileLink.click()
        }
        this.resetForm()
        this.isLoading = false
        this.isActiveModal = false
      }
    },
    formatedDate (date) {
      let formatDate = this.$moment(date, 'YYYY-MM-DD')
      let dayDate = formatDate.date()
      let month = formatDate.format('MMMM')
      let year = formatDate.format('YYYY')
      return {
        day: dayDate,
        month: month,
        year: year
      }
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    }
  },
  watch: {
    active () {
      if (this.active !== this.isActiveModal) {
        this.isActiveModal = this.active
      }
    },
    isActiveModal () {
      if (this.isActiveModal !== this.active) {
        this.$emit('update:active', this.isActiveModal)
      }
    }
  },
  computed: {
    userId () {
      return this.rider ? this.rider.id : null
    },
    switchLabel () {
      return this.allRiders ? 'Todos' : 'Solo uno'
    }
  }
}
</script>
